import Link from "next/link";
import { useState } from "react";
import Select from "react-select";

const Pagination = ({
  totalPages,
  pageNumber,
  handleClick,
  maxItems,
  setMaxItems,
}) => {
  const pages = [...Array(totalPages).keys()].map((num) => num + 1);

  const handlePreviousClick = () => {
    handleClick(pageNumber - 1);
  };

  const handleNextClick = () => {
    handleClick(pageNumber + 1);
  };

  return (
    <nav>
      <div className="nav-links">
        <ul className="rbt-pagination">
          <li className={pageNumber === 1 ? "disabled" : ""}>
            <Link
              href="#"
              aria-label="Previous"
              onClick={() => handlePreviousClick()}
            >
              <i className="feather-chevron-left" />
            </Link>
          </li>
          {pages.map((num) => (
            <li key={num} className={pageNumber === num ? "active" : ""}>
              <Link href="#" onClick={() => handleClick(num)}>
                {num}
              </Link>
            </li>
          ))}

          <li className={pageNumber === totalPages ? "disabled" : ""}>
            <Link href="#" aria-label="Next" onClick={() => handleNextClick()}>
              <i className="feather-chevron-right" />
            </Link>
          </li>
          <div className="rbt-modern-select bg-transparent height-45">
            <Select
              instanceId="sortBySelect"
              className="react-select"
              classNamePrefix="react-select"
              defaultValue={maxItems}
              onChange={setMaxItems}
              options={[
                { value: 5, label: "5" },
                { value: 10, label: "10" },
                { value: 50, label: "50" },
                { value: 100, label: "100" },
              ]}
            />
          </div>
        </ul>
      </div>
    </nav>
  );
};

export default Pagination;
